<div [@triggerName]="prepareRoute(outlet)" class="trigger-animation">
    <router-outlet #outlet="outlet"></router-outlet>
</div>